import type { NavItem } from '@/app/nav/collect'

/** No entry of its own: the shell declares "Messages" (`/messages`, the `chatUnread` badge). */
const nav: NavItem[] = []

export default nav
